import { clsx } from "clsx";
import { type FC } from "react";
import { LoadingBar, LoadingBarIntent } from "widgets";

import style from "@/modules/files/styles/upload.module.scss";
import { FILE_STATUS } from "@/settings/settings.js";

interface FileUploadProgressIndicatorProps {
  uploadStatus: FILE_STATUS;
  progress: number;
}

const FileUploadProgressIndicator: FC<FileUploadProgressIndicatorProps> = (props) => {
  return (
    <div className={clsx(style.loading)}>
      {(props.uploadStatus === FILE_STATUS.UPLOAD_COMPLETE ||
        props.uploadStatus === FILE_STATUS.VALIDATION_COMPLETE) && (
        <LoadingBar progress={100} className={style.loading_bar} intent={LoadingBarIntent.Success} />
      )}

      {(props.uploadStatus === FILE_STATUS.UPLOAD_FAILED || props.uploadStatus === FILE_STATUS.VALIDATION_FAILED) && (
        <LoadingBar progress={100} className={style.loading_bar} intent={LoadingBarIntent.Error} />
      )}

      {props.uploadStatus === FILE_STATUS.VALIDATION_WAITING && (
        <LoadingBar progress={100} className={style.loading_bar} intent={LoadingBarIntent.Warning} />
      )}

      {props.uploadStatus === FILE_STATUS.VALIDATION_PENDING && (
        <div className={style.loading_bar}>
          <LoadingBar isLoading className={style.loading_bar} />
        </div>
      )}

      {props.uploadStatus === FILE_STATUS.UPLOAD_PENDING && (
        <LoadingBar className={style.loading_bar} progress={props.progress} />
      )}
    </div>
  );
};

export { FileUploadProgressIndicator };
